export default {
  createCallLog: 'Create call log',
  viewInSalesforce: 'View in Salesforce',
  createLog: 'Create log',
} as const;
